import { SystemStyleObject } from '@mui/system';

export const containerStyles: SystemStyleObject = { minHeight: 300 };
